import { render, staticRenderFns } from "./dm-detail-dianping.vue?vue&type=template&id=47fc078d&scoped=true"
import script from "./dm-detail-dianping.vue?vue&type=script&lang=js"
export * from "./dm-detail-dianping.vue?vue&type=script&lang=js"
import style0 from "./dm-detail-dianping.vue?vue&type=style&index=0&id=47fc078d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc078d",
  null
  
)

export default component.exports